export const blendWithWhite = (hex: string, ratio: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const blend = (channel: number) => Math.round(255 + (channel - 255) * ratio);
  return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`;
};
